(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[433],{

/***/ "WMQr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Compass", function() { return Compass; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var Compass = function Compass(_ref) {
  var xRef = _ref.xRef,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["xRef"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 200 200"
  }, props, {
    ref: xRef
  }), __jsx("path", {
    d: "M100.1 183.9c-46.2 0-83.6-37.6-83.6-83.6 0-46.2 37.4-83.8 83.6-83.8s83.6 37.6 83.6 83.6c0 46.2-37.4 83.8-83.6 83.8m0-178.9c-52.6 0-95 42.6-95 95 0 52.6 42.4 95 94.8 95 52.6 0 95-42.6 95-95 .2-52.3-42.4-95-94.8-95"
  }), __jsx("path", {
    d: "M107.3 33.9c0 4-3.2 7.2-7.2 7.2s-7.2-3.2-7.2-7.2 3.2-7.2 7.2-7.2c4 .1 7.2 3.2 7.2 7.2m0 132.5c0 4-3.2 7.2-7.2 7.2s-7.2-3.2-7.2-7.2 3.2-7.2 7.2-7.2c4-.2 7.2 3 7.2 7.2m58.9-59c-4 0-7.2-3.2-7.2-7.2s3.2-7.2 7.2-7.2 7.2 3.2 7.2 7.2-3.2 7.2-7.2 7.2m-132.2 0c-4 0-7.2-3.2-7.2-7.2S30 93 34 93s7.2 3.2 7.2 7.2c-.1 4-3.2 7.2-7.2 7.2m116.5-57.5c-1.6-1.6-4.2-1.8-6.2-.6l-45.6 30c-2.2.2-4.4.6-6.6 1.6-7.5 3.2-12.1 10.2-12.9 17.8l-30.1 45.8c-1.2 2-1 4.4.6 6.2 1 1 2.2 1.4 3.4 1.4 1 0 1.8-.2 2.6-.8l45.6-30.1c2.4-.2 4.8-.6 7-1.6 7.8-3.4 12.5-10.6 12.9-18.5l29.9-45.2c1.2-1.9 1-4.4-.6-6zM70 130.1l12.3-18.7c1.6 2.6 3.8 4.8 6.4 6.4L70 130.1zm30.3-19.9c-5.6 0-10-4.4-10-10s4.4-10 10-10 10 4.4 10 10-4.6 10-10 10zm17.5-21.5c-1.6-2.6-3.8-4.6-6.4-6.2l18.3-12.1-11.9 18.3z"
  }));
};

/***/ })

}]);